import { Injectable } from '@angular/core';

/** Claves fijas del flujo Radicación de traslados y pantallas relacionadas. */
const RADICACION_TRASLADOS_FIXED_KEYS = [
  'frmConsultState',
  'tipoNovedadSelectorState',
  'estado_proceso',
  'sarlaft_form',
  'autorizacion_radicacion_form',
] as const;

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  save(key: string, value: any) {
    localStorage.setItem(key, JSON.stringify(value));
  }

  load(key: string) {
    const saved = localStorage.getItem(key);
    return saved ? JSON.parse(saved) : null;
  }

  remove(key: string) {
    localStorage.removeItem(key);
  }

  /**
   * Borra todo lo persistido para el proceso de radicación (incl. tipo de novedad,
   * cuestionarios, soportes, SARLAFT, etc.). Usar desde «Limpiar» o reset completo.
   */
  clearRadicacionTrasladosSession(
    healthQuestMaxIndex = 32,
    soporteMaxIndex = 32
  ): void {
    for (const k of RADICACION_TRASLADOS_FIXED_KEYS) {
      this.remove(k);
    }
    for (let i = 0; i < healthQuestMaxIndex; i++) {
      this.remove(`healthQuest_${i}`);
    }
    for (let i = 0; i < soporteMaxIndex; i++) {
      this.remove(`soportes_${i}`);
    }
  }
}
